// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   Custom Date‑Time Picker — full rewrite
   Glassmorphism + segmented input + spinners
   ═══════════════════════════════════════════════ */

/* ─── Wrapper ─── */
.cdp-wrapper {
  position: relative;
  width: 100%;
}

/* ─── Input Bar ─── */
.cdp-input-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-secondary);
  border: 1.5px solid var(--border-color);
  border-radius: 12px;
  padding: 4px 6px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  gap: 4px;
}

.cdp-input-bar.open,
.cdp-input-bar:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.10);
}

.cdp-input-bar.error {
  border-color: var(--accent-error, #dc2626);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.10);
}

/* ─── Smart Input ─── */
.cdp-smart-input {
  flex: 1 1;
  min-width: 0;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--font-data, 'Fira Code', monospace);
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-primary);
  padding: 6px 8px;
  border-radius: 6px;
  transition: background 0.18s ease, color 0.18s ease;
  caret-color: var(--accent-primary);
  line-height: 1.2;
}

.cdp-smart-input::placeholder {
  color: var(--text-secondary);
  opacity: 0.5;
  font-weight: 400;
}

.cdp-smart-input:focus {
  background: rgba(37, 99, 235, 0.04);
}

/* ─── Input action buttons ─── */
.cdp-input-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.cdp-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.cdp-icon-btn:hover {
  background: rgba(37, 99, 235, 0.10);
  color: var(--accent-primary);
}

.cdp-icon-btn.active {
  color: var(--accent-primary);
}

.cdp-clear-btn:hover {
  background: rgba(220, 38, 38, 0.08);
  color: var(--accent-error, #dc2626);
}

/* ─── Overlay (портал в body) ─── */
/* Центрирует календарь по вьюпорту, чтобы он не уходил вниз за экран внутри
   узких меню фильтров; клик по подложке закрывает и возвращает к фильтрам. */
.cdp-overlay {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

/* ─── Popover ─── */
.cdp-popover {
  position: relative;
  z-index: 1;
  max-height: calc(100vh - 32px);
  overflow: auto;
  overscroll-behavior: contain;
  background: var(--bg-primary);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
  font-family: var(--font-body);
}

/* Поле ручного ввода внутри карточки календаря (портал/центрирование) */
.cdp-popover-input-bar {
  margin: 12px 12px 0;
}

/* ─── Body layout ─── */
.cdp-body {
  display: flex;
  flex-direction: column;
}

/* ─── Tabs ─── */
.cdp-tabs {
  display: flex;
  background: rgba(0, 0, 0, 0.02);
  padding: 6px;
  gap: 4px;
  border-bottom: 1px solid var(--border-glass);
}

.cdp-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.cdp-tab:hover {
  background: rgba(37, 99, 235, 0.05);
  color: var(--accent-primary);
}

.cdp-tab.active {
  background: var(--nav-hover-bg);
  color: var(--accent-primary);
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}

/* ─── Calendar ─── */
.cdp-calendar {
  padding: 16px;
  width: 268px;
  max-width: 100%;
}

.cdp-cal-header {
  display: grid;
  grid-template-columns: 30px 1fr 30px;
  align-items: center;
  margin-bottom: 14px;
  gap: 6px;
}

.cdp-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.cdp-nav-btn:hover {
  background: rgba(37, 99, 235, 0.10);
  color: var(--accent-primary);
}

.cdp-month-label {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
}

.cdp-month-name {
  font-weight: 700;
  font-size: 13.5px;
  color: var(--text-primary);
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cdp-month-year {
  font-weight: 500;
  font-size: 13.5px;
  color: var(--text-secondary);
  opacity: 0.75;
  flex-shrink: 0;
}

/* Weekday labels */
.cdp-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  opacity: 0.7;
  margin-bottom: 6px;
}

/* Grid wrapper + grid */
.cdp-grid-wrapper {
  position: relative;
  overflow: hidden;
  height: 228px;
}

.cdp-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 3px;
  position: absolute;
  width: 100%;
  height: 100%;
}

/* Day buttons */
.cdp-day {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.18s ease;
  position: relative;
}

.cdp-day:hover:not(.sel) {
  background: rgba(37, 99, 235, 0.10);
  color: var(--accent-primary);
}

.cdp-day.dim {
  color: var(--text-secondary);
  opacity: 0.38;
}

.cdp-day.today {
  font-weight: 700;
  color: var(--accent-primary);
}

.cdp-day.today::after {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--accent-primary);
  opacity: 0.6;
}

.cdp-day.sel {
  background: var(--accent-primary);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 3px 10px rgba(37, 99, 235, 0.35);
}

.cdp-day.sel::after {
  display: none;
}

/* ─── Time View ─── */
.cdp-time-view {
  width: 268px; /* match calendar width */
  max-width: 100%;
  height: 294px; /* match calendar height approx */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  overscroll-behavior: contain;
}

/* Prevent horizontal overflow in narrow layouts */
.cdp-popover {
  max-width: 100%;
}

@media (max-width: 420px) {
  .cdp-stepper-container {
    padding: 18px 18px;
  }
}

.cdp-stepper-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid var(--border-glass);
  padding: 24px 32px;
  border-radius: 16px;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.02);
  touch-action: none;
}

.cdp-stepper-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.cdp-stepper-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.cdp-stepper-btn:hover {
  background: rgba(37, 99, 235, 0.10);
  color: var(--accent-primary);
  transform: scale(1.05);
}

.cdp-stepper-val {
  font-size: 32px;
  font-weight: 700;
  font-family: var(--font-data, monospace);
  color: var(--text-primary);
  width: 56px;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: none;
}

.cdp-stepper-divider {
  font-size: 32px;
  font-weight: 700;
  color: var(--text-secondary);
  opacity: 0.5;
  padding-bottom: 24px;
  -webkit-user-select: none;
          user-select: none;
}

.cdp-stepper-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.7;
}

/* ─── Footer ─── */
.cdp-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px 10px;
  border-top: 1px solid var(--border-glass);
}

.cdp-now-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.cdp-now-btn:hover {
  background: rgba(37, 99, 235, 0.08);
  color: var(--accent-primary);
}

.cdp-done-btn {
  background: var(--accent-primary);
  color: #fff;
  border: none;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 18px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}

.cdp-done-btn:hover {
  background: var(--accent-hover, #1d4ed8);
  box-shadow: 0 3px 12px rgba(37, 99, 235, 0.35);
  transform: translateY(-1px);
}
`, "",{"version":3,"sources":["webpack://./src/css/custom-datepicker.css"],"names":[],"mappings":"AAAA;;;oDAGoD;;AAEpD,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;EAC1D,qBAAqB;EACrB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;;EAEE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;6EAC6E;AAC7E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,YAAY,EAAE,yBAAyB;EACvC,eAAe;EACf,aAAa,EAAE,iCAAiC;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;AAC7B","sourcesContent":["/* ═══════════════════════════════════════════════\n   Custom Date‑Time Picker — full rewrite\n   Glassmorphism + segmented input + spinners\n   ═══════════════════════════════════════════════ */\n\n/* ─── Wrapper ─── */\n.cdp-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* ─── Input Bar ─── */\n.cdp-input-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--border-color);\n  border-radius: 12px;\n  padding: 4px 6px;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  gap: 4px;\n}\n\n.cdp-input-bar.open,\n.cdp-input-bar:focus-within {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.10);\n}\n\n.cdp-input-bar.error {\n  border-color: var(--accent-error, #dc2626);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.10);\n}\n\n/* ─── Smart Input ─── */\n.cdp-smart-input {\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--font-data, 'Fira Code', monospace);\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--text-primary);\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: background 0.18s ease, color 0.18s ease;\n  caret-color: var(--accent-primary);\n  line-height: 1.2;\n}\n\n.cdp-smart-input::placeholder {\n  color: var(--text-secondary);\n  opacity: 0.5;\n  font-weight: 400;\n}\n\n.cdp-smart-input:focus {\n  background: rgba(37, 99, 235, 0.04);\n}\n\n/* ─── Input action buttons ─── */\n.cdp-input-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.cdp-icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cdp-icon-btn:hover {\n  background: rgba(37, 99, 235, 0.10);\n  color: var(--accent-primary);\n}\n\n.cdp-icon-btn.active {\n  color: var(--accent-primary);\n}\n\n.cdp-clear-btn:hover {\n  background: rgba(220, 38, 38, 0.08);\n  color: var(--accent-error, #dc2626);\n}\n\n/* ─── Overlay (портал в body) ─── */\n/* Центрирует календарь по вьюпорту, чтобы он не уходил вниз за экран внутри\n   узких меню фильтров; клик по подложке закрывает и возвращает к фильтрам. */\n.cdp-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 4000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(15, 23, 42, 0.28);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n/* ─── Popover ─── */\n.cdp-popover {\n  position: relative;\n  z-index: 1;\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n  overscroll-behavior: contain;\n  background: var(--bg-primary);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);\n  font-family: var(--font-body);\n}\n\n/* Поле ручного ввода внутри карточки календаря (портал/центрирование) */\n.cdp-popover-input-bar {\n  margin: 12px 12px 0;\n}\n\n/* ─── Body layout ─── */\n.cdp-body {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ─── Tabs ─── */\n.cdp-tabs {\n  display: flex;\n  background: rgba(0, 0, 0, 0.02);\n  padding: 6px;\n  gap: 4px;\n  border-bottom: 1px solid var(--border-glass);\n}\n\n.cdp-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cdp-tab:hover {\n  background: rgba(37, 99, 235, 0.05);\n  color: var(--accent-primary);\n}\n\n.cdp-tab.active {\n  background: var(--nav-hover-bg);\n  color: var(--accent-primary);\n  box-shadow: 0 2px 6px rgba(0,0,0,0.04);\n}\n\n/* ─── Calendar ─── */\n.cdp-calendar {\n  padding: 16px;\n  width: 268px;\n  max-width: 100%;\n}\n\n.cdp-cal-header {\n  display: grid;\n  grid-template-columns: 30px 1fr 30px;\n  align-items: center;\n  margin-bottom: 14px;\n  gap: 6px;\n}\n\n.cdp-nav-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cdp-nav-btn:hover {\n  background: rgba(37, 99, 235, 0.10);\n  color: var(--accent-primary);\n}\n\n.cdp-month-label {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.cdp-month-name {\n  font-weight: 700;\n  font-size: 13.5px;\n  color: var(--text-primary);\n  text-transform: capitalize;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cdp-month-year {\n  font-weight: 500;\n  font-size: 13.5px;\n  color: var(--text-secondary);\n  opacity: 0.75;\n  flex-shrink: 0;\n}\n\n/* Weekday labels */\n.cdp-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  opacity: 0.7;\n  margin-bottom: 6px;\n}\n\n/* Grid wrapper + grid */\n.cdp-grid-wrapper {\n  position: relative;\n  overflow: hidden;\n  height: 228px;\n}\n\n.cdp-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-template-rows: repeat(6, 1fr);\n  gap: 3px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n/* Day buttons */\n.cdp-day {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.18s ease;\n  position: relative;\n}\n\n.cdp-day:hover:not(.sel) {\n  background: rgba(37, 99, 235, 0.10);\n  color: var(--accent-primary);\n}\n\n.cdp-day.dim {\n  color: var(--text-secondary);\n  opacity: 0.38;\n}\n\n.cdp-day.today {\n  font-weight: 700;\n  color: var(--accent-primary);\n}\n\n.cdp-day.today::after {\n  content: '';\n  position: absolute;\n  bottom: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  opacity: 0.6;\n}\n\n.cdp-day.sel {\n  background: var(--accent-primary);\n  color: #fff;\n  font-weight: 700;\n  box-shadow: 0 3px 10px rgba(37, 99, 235, 0.35);\n}\n\n.cdp-day.sel::after {\n  display: none;\n}\n\n/* ─── Time View ─── */\n.cdp-time-view {\n  width: 268px; /* match calendar width */\n  max-width: 100%;\n  height: 294px; /* match calendar height approx */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 20px;\n  overscroll-behavior: contain;\n}\n\n/* Prevent horizontal overflow in narrow layouts */\n.cdp-popover {\n  max-width: 100%;\n}\n\n@media (max-width: 420px) {\n  .cdp-stepper-container {\n    padding: 18px 18px;\n  }\n}\n\n.cdp-stepper-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-glass);\n  padding: 24px 32px;\n  border-radius: 16px;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.02);\n  touch-action: none;\n}\n\n.cdp-stepper-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.cdp-stepper-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cdp-stepper-btn:hover {\n  background: rgba(37, 99, 235, 0.10);\n  color: var(--accent-primary);\n  transform: scale(1.05);\n}\n\n.cdp-stepper-val {\n  font-size: 32px;\n  font-weight: 700;\n  font-family: var(--font-data, monospace);\n  color: var(--text-primary);\n  width: 56px;\n  text-align: center;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: none;\n}\n\n.cdp-stepper-divider {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  opacity: 0.5;\n  padding-bottom: 24px;\n  user-select: none;\n}\n\n.cdp-stepper-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.7;\n}\n\n/* ─── Footer ─── */\n.cdp-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px 10px;\n  border-top: 1px solid var(--border-glass);\n}\n\n.cdp-now-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: transparent;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.cdp-now-btn:hover {\n  background: rgba(37, 99, 235, 0.08);\n  color: var(--accent-primary);\n}\n\n.cdp-done-btn {\n  background: var(--accent-primary);\n  color: #fff;\n  border: none;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 5px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);\n}\n\n.cdp-done-btn:hover {\n  background: var(--accent-hover, #1d4ed8);\n  box-shadow: 0 3px 12px rgba(37, 99, 235, 0.35);\n  transform: translateY(-1px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
